import { cn } from "../lib/cn";

/** Official brand assets, used as-is (frontend/public/brand/):
 *  mark.png        — the square interlocking-frames tile (also the favicon)
 *  logo.png        — the full SHINEY WISE logo for light backgrounds
 *  logo-light.png  — white-on-dark variant for dark backgrounds */

export function LogoMark({ className, size = 32 }: { className?: string; size?: number }) {
  return (
    <img
      src="/brand/mark.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={cn("shrink-0 select-none", className)}
      draggable={false}
    />
  );
}

/** Full logo. `light` serves the white-on-dark asset for dark surfaces.
 *  `size` matches the old mark-height API; the wordmark image is scaled from
 *  it. `subtitle` renders the product name underneath. */
export function Logo({
  className,
  size = 32,
  showWordmark = true,
  subtitle,
  light = false,
}: {
  className?: string;
  size?: number;
  showWordmark?: boolean;
  subtitle?: string;
  light?: boolean;
}) {
  if (!showWordmark) return <LogoMark size={size} className={className} />;
  return (
    <span className={cn("inline-flex items-center", className)}>
      <span className="leading-none">
        <img
          src={light ? "/brand/logo-light.png" : "/brand/logo.png"}
          alt="Shiney Wise"
          style={{ height: Math.round(size * 0.85) }}
          className="w-auto select-none"
          draggable={false}
        />
        {subtitle && (
          <span
            className={cn(
              "mt-1 block text-[0.62rem] font-semibold uppercase tracking-[0.18em]",
              light ? "text-slate-500" : "text-slate-400",
            )}
          >
            {subtitle}
          </span>
        )}
      </span>
    </span>
  );
}
